export enum AD_TYPE {
  NO_AD = 0,
  CSAI = 1,
  SSAI = 2,
}
